import useTranslator from "../../hooks/useTranslator";
import { Select, TextField } from "../../components/design";

const CompanyOnboardingInfoSection = ({
  isCompany,
  formData,
  handleInputChange,
  errors,
}) => {
  const { _t } = useTranslator();

  if (!isCompany) return null;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <div className="company-info-banner-wrap">
        <div className="company-info-banner-content">
          {_t("companyTenantBannerText", "Company tenant registration banner")}
        </div>
      </div>

      <div className="company-section-divider">
        {_t("companyDetailsSection", "Company section headers")}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "0 16px",
        }}
      >
        <div style={{ gridColumn: "1 / -1", minWidth: 0 }}>
          <TextField
            id="company_legal_name"
            name="company_legal_name"
            label={_t("legalName", "Company data field labels")}
            placeholder={_t(
              "companyLegalNamePlaceholder",
              "Company data field placeholders"
            )}
            value={formData.company_legal_name || ""}
            onChange={handleInputChange}
            error={errors.company_legal_name}
          />
        </div>

        <TextField
          id="company_cif"
          name="company_cif"
          label={_t("taxIdCif", "Company data field labels")}
          placeholder={_t("cifPlaceholder", "Company data field placeholders")}
          value={formData.company_cif || ""}
          onChange={handleInputChange}
          maxLength={9}
          error={errors.company_cif}
        />

        <Select
          id="company_type"
          name="company_type"
          label={_t("companyType", "Company data field labels")}
          placeholder={_t("pleaseSelect")}
          value={formData.company_type || ""}
          onChange={handleInputChange}
          error={errors.company_type}
          options={[
            {
              value: "SL",
              label: _t("limitedCompanySl", "Company type options"),
            },
            {
              value: "SA",
              label: _t("publicLimitedCompanySa", "Company type options"),
            },
            {
              value: "cooperativa",
              label: _t("cooperative", "Company type options"),
            },
            { value: "other", label: _t("other") },
          ]}
        />

        <div style={{ gridColumn: "1 / -1", minWidth: 0 }}>
          <TextField
            id="company_cnae"
            name="company_cnae"
            label={_t("cnaeBusinessActivity", "Company data field labels")}
            placeholder={_t(
              "cnaePlaceholder",
              "Company data field placeholders"
            )}
            value={formData.company_cnae || ""}
            onChange={handleInputChange}
            error={errors.company_cnae}
          />
        </div>
      </div>

      <div className="company-section-divider" style={{ marginTop: "4px" }}>
        {_t("legalRepresentativeSection", "Company section headers")}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "0 16px",
        }}
      >
        <Select
          id="company_representative_position"
          name="company_representative_position"
          label={_t("position", "Company data field labels")}
          placeholder={_t("pleaseSelect")}
          value={formData.company_representative_position || ""}
          onChange={handleInputChange}
          error={errors.company_representative_position}
          options={[
            {
              value: "sole_administrator",
              label: _t(
                "soleAdministrator",
                "Legal representative position options"
              ),
            },
            {
              value: "authorized_signatory",
              label: _t(
                "authorizedSignatory",
                "Legal representative position options"
              ),
            },
            {
              value: "ceo",
              label: _t("ceo", "Legal representative position options"),
            },
          ]}
        />

        <TextField
          id="company_identity_number"
          name="identity_number"
          label={_t("representativeId", "Company data field labels")}
          placeholder={_t(
            "enterYourRepresentativesId",
            "Text used in onboarding process"
          )}
          value={formData.identity_number || ""}
          onChange={handleInputChange}
          maxLength={9}
          error={errors.identity_number}
          hint={_t("sameDocumentEnteredAbove", "Company data field hints")}
        />
      </div>
    </div>
  );
};

export default CompanyOnboardingInfoSection;
